import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Layout } from '@apps/card/components/Layout';
import { OrderDetails } from '@apps/card';

interface PrintOrderDetailsProps {
  printOrderNumber: string;
}

export const PrintOrderDetails = (props: PrintOrderDetailsProps) => {
  const { printOrderNumber } = props;

  return (
    <Layout.Grid>
      <Layout.Main>
        <Flex justifyContent="center" paddingTop={10} paddingBottom={pxToRem(97)}>
          <OrderDetails printOrderNumber={printOrderNumber} />
        </Flex>
      </Layout.Main>
    </Layout.Grid>
  );
};
